import { slotObjectToDataTestIds } from '@elliemae/ds-system';

export const DSFloatingWrapperName = 'DSFloatingwrapper';

export const DSFloatingWrapperSlots = {
  ROOT: 'root',
  CONTENT: 'content',
  ARROW: 'arrow',
  ARROW_SHADOW: 'arrow_shadow',
  ARROW_FILL: 'arrow_fill',
};

export const DSFloatingWrapperDataTestids = {
  ...slotObjectToDataTestIds(DSFloatingWrapperName, DSFloatingWrapperSlots),
  // for legacy reasons we have to keep those around and override the slots...
  ROOT: 'ds-floating-wrapper-root',
  ARROW: 'ds-tooltip-arrow',
};
